import CrosbyTheme from "./crosby";
import HazelTheme from "./hazel";
import NolanTheme from "./nolan";
import SeldonTheme from "./starter-hub";
import { createThemeRegistry } from "./utils";

export * from "./types";

export const installThemes = createThemeRegistry(
  CrosbyTheme,
  SeldonTheme,
  HazelTheme,
  NolanTheme
);
